import { alpha, makeStyles } from '@material-ui/core';

import { BANNER_WEBINAR_HEIGHT, COLORS, FONTS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: '100%',
      height: BANNER_WEBINAR_HEIGHT,
      backgroundColor: '#BDA5F1',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    webinarTag: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      columnGap: theme.spacing(1),
      padding: theme.spacing(0.75, 1.5),
      backgroundColor: alpha(COLORS.gray.white, 0.4),
      borderRadius: theme.shape.borderRadiusSmall,
      color: COLORS.primary.active,
      width: 136,
    },
    iconWebinar: {
      fontSize: theme.typography.pxToRem(16),
      color: COLORS.primary.active,
    },
    title: {
      color: COLORS.gray.black,
      margin: theme.spacing(0, 3, 0, 1.5),
      fontFamily: FONTS.DMSans,
      '&:hover': {
        color: COLORS.gray.black,
      },
    },
    time: {
      color: '#8039E9',
    },
    button: {
      backgroundColor: COLORS.gray.black,
      color: COLORS.gray.white,
      borderRadius: 60,
      padding: theme.spacing(1.125, 3.375),
      '&:hover': {
        backgroundColor: '#8039E9',
      },
      '&:active': {
        backgroundColor: COLORS.gray.black,
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(2),
      '&:hover': {
        backgroundColor: 'unset',
      },
    },
    closeIcon: {
      fontSize: theme.typography.pxToRem(12),
      color: COLORS.gray.black,
    },
  }),
  {
    name: 'WebinarBanner',
  }
);
